import { useState, useEffect, useCallback } from "react";
import moment from "moment";
import BpjsItem from "./BpjsItem";
import BpjsEdit from "./BpjsEdit";
import ButtonDropdown from "../../../components/ButtonDropdown";
import WorkerService from "../../../services/Worker";
import { toast } from "react-toastify";
import { Toast } from "../../../config/Toast";
import "react-toastify/dist/ReactToastify.css";
import { convertToRupiah } from "../../../helper/RupiahDashboard";

const Bpjs = (props) => {
  const { data, activeModal, closeModal, masterBpjs, submitBpjsHandler } = props;
  const dataMaster = data || {};
  const modalClass = activeModal ? "effect-scale show" : "";
  const modalStyle = activeModal ? { display: "block", paddingRight: "17px", background: "rgba(0, 0, 0, 0.5)" } : {};

  const notifyFailed = (message) => toast.error(message, Toast);

  const [list, setList] = useState([]);
  const [year, setYear] = useState(moment().format("YYYY"));
  const [deposit, setDeposit] = useState(data?.amount || 0);
  const [editData, setEditData] = useState(null);
  const [editModal, setEditModal] = useState(false);

  const curYear = moment().format("YYYY");

  const yearHandler = useCallback(
    (selectedYear) => {
      const yearToUse = selectedYear || year || curYear;
      setYear(yearToUse);

      WorkerService.bpjsHistory(dataMaster.user_id, yearToUse)
        .then((res) => {
          setList(res?.data?.data || []);
        })
        .catch((err) => {
          console.error("BPJS History Error:", err);
        });
    },
    [dataMaster.user_id, year, curYear]
  );

  useEffect(() => {
    if (activeModal) {
      yearHandler();
    }
  }, [activeModal, yearHandler]);

  const dropdownObj = [];
  for (let i = curYear; i >= 2022; i--) {
    dropdownObj.push({
      name: i,
      clickFunction: () => yearHandler(i),
    });
  }
  const action = <ButtonDropdown button="btn-dark btn-sm px-4" title={year} dropdown={dropdownObj} />;

  const submitHandler = async (payload) => {
    const result = await submitBpjsHandler(dataMaster.user_id, payload);

    if (result?.success) {
      yearHandler();
      closeEditModal();
      setDeposit(result.deposit);
    }
  };

  const editHandler = (item) => {
    if (deposit < masterBpjs) {
      notifyFailed("Saldo deposit BPJS tidak cukup");
      return;
    }

    setEditData({
      data: item,
      dataDetail: data,
    });
    setEditModal(true);
  };

  const closeEditModal = () => {
    setEditModal(false);
    setEditData(null);
  };

  return (
    <>
      <div className={`modal fade ${modalClass}`} id="modalDetailBPJS" style={modalStyle} role="dialog" aria-modal="true">
        <div className="modal-dialog modal-dialog-scrollable modal-xl text-center modal-dialog-centered" role="document">
          <div className="modal-content modal-content-demo shadow-lg">
            <div className="modal-header">
              <h5 className="modal-title fw-bold">
                {`List Pembayaran BPJS | ${dataMaster.name || "N/A"}`} - {dataMaster.id || "N/A"}
              </h5>
              <button aria-label="Close" className="btn-close" data-bs-dismiss="modal" onClick={closeModal}>
                <span aria-hidden="true">×</span>
              </button>
            </div>

            <div className="modal-body">
              <div className="flex flex-row align-items-center w-full gap-3 mb-3">
                <h5 className="fw-bold mb-0">Saldo Deposit: <span className="text-success">Rp. {convertToRupiah(deposit)}</span></h5>
                <div className="flex-1"></div>
                <h6 className="fw-bold mb-0">Tahun</h6>
                <div className="text-end">{action}</div>
              </div>

              <table className="table table-bordered">
                <thead>
                  <tr>
                    <th>Month</th>
                    <th>Status</th>
                    <th>Date</th>
                    <th>Type</th>
                    <th>Amount</th>
                    <th>BPJS</th>
                    <th>Note</th>
                    <th>#</th>
                  </tr>
                </thead>

                <tbody>
                  {list.length > 0 ? (
                    list.map((item) => (
                      <BpjsItem
                        key={item.id}
                        data={item}
                        editHandler={() => editHandler(item)}
                      />
                    ))
                  ) : (
                    <tr>
                      <td colSpan="9" className="text-center text-muted">
                        Tidak ada data BPJS untuk tahun {year}
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>

      {editModal && editData && (
        <BpjsEdit
          data={editData.data}
          activeModal={editModal}
          closeModal={closeEditModal}
          onSubmitHandler={submitHandler}
          year={year}
        />
      )}
    </>
  );
};

export default Bpjs;
